import * as React from 'react';

const AuthenticityDiamond16 = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 16 16", width: 16, height: 16, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.272 13.774.582 7.579A2.053 2.053 0 0 1 .577 4.72l2.347-2.489A2.38 2.38 0 0 1 4.657 1.5h6.686c.663 0 1.295.266 1.733.731l2.347 2.49a2.05 2.05 0 0 1-.005 2.858l-5.69 6.195c-.919.968-2.537.968-3.456 0m1.094-1.026c.327.336.94.336 1.268 0l5.688-6.193.008-.009a.554.554 0 0 0 .002-.797l-2.347-2.488A.89.89 0 0 0 11.343 3H4.657a.89.89 0 0 0-.642.26L1.668 5.75a.554.554 0 0 0 .002.796l.008.009zm4.377-6.864-1.209-.415-.41-1.206a.37.37 0 0 0-.14-.19.41.41 0 0 0-.466 0 .37.37 0 0 0-.14.19l-.4 1.206-1.209.405a.43.43 0 0 0-.195.15.39.39 0 0 0 0 .453.43.43 0 0 0 .195.149l1.21.405.399 1.206a.37.37 0 0 0 .14.19.41.41 0 0 0 .466 0 .37.37 0 0 0 .14-.19l.41-1.206 1.21-.405a.43.43 0 0 0 .186-.15.39.39 0 0 0 0-.442.43.43 0 0 0-.187-.15",
    clipRule: "evenodd"
  }
));
AuthenticityDiamond16.Size = 16;
AuthenticityDiamond16.Title = "AuthenticityDiamond";

export { AuthenticityDiamond16 as default };
